import { watchEffect } from "vue";
import { Options, setup, Vue } from "vue-class-component";
import { useRouter } from "vue-router";

import { useI18n } from "@/shared/composables/use-i18n";
import { MyAccountTab } from "@/dashboard/models/dashboard-enums";
import ContactInfo from "@/dashboard/my-account/contact-info/contact-info.vue";
import ChangePassword from "@/dashboard/my-account/change-password/change-password.vue";
import DashboardSidebar from "@/dashboard/dashboard-sidebar/dashboard-sidebar.vue";
import { dashboardModel } from "@/dashboard/dashboard.model";

@Options({
    components: {
        "dashboard-sidebar": DashboardSidebar,
        "contact-info": ContactInfo,
        "change-password": ChangePassword,
    },
})
export class MyAccount extends Vue {
    i18n = setup(useI18n);
    router = setup(useRouter);
    myAccountTab = MyAccountTab;
    tabActivity = MyAccountTab.contact;

    mounted() {
        watchEffect(() => {
            this.tabActivity = this.router.currentRoute.params.tab as MyAccountTab;
        });
    }

    get canOnlyShowPageToAdmin(): boolean {
        return dashboardModel.canOnlyShowPageToAdmin.value;
    }
}
